/**
 * Section impression names for /wedding-photo-sharing.
 *
 * `trackSectionViewed` is section-name-agnostic, but the shared analytics module
 * documents its supported values as a closed set, each with a named wrapper so a
 * call site never spells the section string itself. That module is vendored
 * byte-identical into `invite/src/lib/analytics/` and guarded by
 * `npm run verify:analytics`, so adding page-specific wrappers there would mean
 * editing the invite app to instrument a landing-page section. These constants
 * keep the rule the wrappers exist to enforce — one owner per string, never a
 * literal at a call site — without that blast radius.
 *
 * Four impressions, not eleven: enough to see whether a search visitor gets
 * through the guest flow, the positioning, the objections and the close, without
 * turning the funnel report into noise.
 */
export const WPS_SECTION = {
  STEPS: "wedding_photo_sharing_steps",
  ARC: "wedding_photo_sharing_arc",
  FAQ: "wedding_photo_sharing_faq",
  FINAL_CTA: "wedding_photo_sharing_final_cta",
};
